import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Auth from '@aws-amplify/auth';
import { Hub } from '@aws-amplify/core';
import { NbIconLibraries, NbSpinnerService } from '@nebular/theme';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, filter, timeout } from 'rxjs/operators';
import { fetchContract, fetchUserInfoSuccess } from './app.actions';
import { AppState } from './app.models';
import { selectQueryParams } from './app.selector';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  initialized: boolean;
  constructor(
    private store: Store,
    public translate: TranslateService,
    private iconLibraries: NbIconLibraries,
    private spinner: NbSpinnerService,
    private router: Router,
  ) {
    translate.addLangs(['en', 'de']);
    translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|de/) ? browserLang : 'en');

    this.iconLibraries.registerSvgPack('custom', {
      'folder-doc': '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><style type="text/css">.st0{stroke:#000000;stroke-width:0.426;stroke-miterlimit:10;}.st1{stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}</style><g id="Ebene_1"><g><path d="M18.5,22.5h-15c-1.4,0-2.5-1.1-2.5-2.4V7.9c0-1.4,1.1-2.4,2.5-2.4h4.6c0.3,0,0.6,0.1,0.8,0.4l2.6,3.2h7c1.4,0,2.5,1,2.5,2.4c0,0,0,0,0,0v8.6C21,21.4,19.9,22.5,18.5,22.5z M3,15.8v4.3c0,0.3,0.2,0.4,0.5,0.4c0,0,0,0,0,0h15c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0,0v-8.6c0-0.3-0.2-0.4-0.5-0.4c0,0,0,0,0,0H11c-0.3,0-0.6-0.1-0.8-0.4L7.6,7.5H3.5C3.2,7.5,3,7.7,3,7.9c0,0,0,0,0,0V15.8z"/></g></g><g id="Ebene_2"><g><g><path class="st0" d="M19.9,6.7l-5.7-3.2c0,0,0,0,0,0c-0.7-0.4-1.6-0.2-2.1,0.6L9.5,9c0.1,0.2,0.2,0.3,0.2,0.5c0.2,0.1,0.4,0.3,0.6,0.5l2.9-5.2c0,0,0,0,0,0c0.1-0.1,0.3-0.2,0.4-0.1l5.7,3.2c0,0,0,0,0,0c0.2,0.1,0.2,0.3,0.1,0.4l-1.2,2.1c0.4,0.1,0.8,0.3,1.1,0.5l1.2-2.1c0,0,0,0,0,0C20.9,8.1,20.7,7.1,19.9,6.7z"/></g></g></g><g id="Ebene_3"><line class="st1" x1="13.6" y1="7.5" x2="16.8" y2="9.1"/></g></svg>',
    });
  }

  async initApp() {
    const session = await Auth.currentSession().catch(console.log);
    if (session) {
      const userInfo = await Auth.currentUserInfo()
      this.store.dispatch(fetchUserInfoSuccess({ payload: userInfo }));
      this.store.dispatch(fetchContract());
      this.store.select((state: AppState) => state.contract.fetched)
        .pipe(
          filter(fetched => fetched),
          timeout(2500),
          catchError(error => of(true))
        )
        .subscribe(() => this.initialized = true);
    } else {
      this.initialized = true;
    }
  }

  ngOnInit() {
    //oauth callback, e.g twitter
    this.store.select(selectQueryParams)
      .pipe(
        filter(p => !!p && p.route && p.provider)
      )
      .subscribe(p => {
        const { route, ...state } = p
        this.router.navigate([p.route], { state });
      })

    //oauth2 callback, e.g twitter
    this.store.select(selectQueryParams)
      .pipe(
        filter(p => !!p && p.state && p.code)
      )
      .subscribe(p => {
        this.router.navigate([p.state], { state: p });
      })

    this.spinner.load();

    this.initApp();

    Hub.listen('auth', data => {
      if (data.payload.event === 'signIn') {
        this.initApp();
      }
    });
  }
}
